import { render, staticRenderFns } from "./trilateralCooperate.vue?vue&type=template&id=55e4e0d0&scoped=true"
import script from "./trilateralCooperate.vue?vue&type=script&lang=js"
export * from "./trilateralCooperate.vue?vue&type=script&lang=js"
import style0 from "./trilateralCooperate.vue?vue&type=style&index=0&id=55e4e0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4e0d0",
  null
  
)

export default component.exports